



























import { mixins } from 'vue-class-component'
import { Component, Prop, Watch } from 'vue-property-decorator'
import AppTextSearch from '@/components/AppTextSearch.vue'
import AppTextField from '@/components/AppTextField.vue'
import AppSelector from '@/components/AppSelector.vue'
import AppDatePicker from '@/components/AppDatePicker.vue'
import AppSelectorMulti from '@/components/AppSelectorMulti.vue'
import AppTextarea from '@/components/AppTextarea.vue'
import { taskPriorityValues } from '@/modules/Task/helpers/task'
import { Task, TaskInfoInput } from '@/modules/Task/interfaces/task'
import SearchUser from '@/mixins/search-queries/search-user'
import { User } from '@/modules/User/interfaces/user'

@Component({
  components: {
    AppTextSearch,
    AppTextField,
    AppSelector,
    AppDatePicker,
    AppSelectorMulti,
    AppTextarea
  }
})
export default class TaskFormInfo extends mixins(SearchUser) {
  @Prop({ type: Object as () => TaskInfoInput }) value!: TaskInfoInput

  taskPriorityValues = taskPriorityValues

  get userOptions () {
    return this.candidatesUser.map((user: User) => {
      return {
        id: +user.id,
        value: user.username
      }
    })
  }

  validate () {
    return (this.$refs.form as Vue & { validate: () => boolean }).validate()
  }
}
